import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { TrapFocusModule } from '®shared/trap-focus';
import { UriModule } from '®shared/url-utils';

import { RequestDigitisationModalComponent } from './request-digitisation-modal.component';
import { RequestDigitisationEffects } from './request-digitisation.effects';
import { requestDigitisationReducer } from './request-digitisation.reducer';
import { RequestDigitisationService } from './request-digitisation.service';
import {
  STATE_FEATURE_REQUEST_DIGITISATION,
  getInitialRequestDigitisationState,
} from './request-digitisation.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([RequestDigitisationEffects]),
    ReactiveFormsModule,
    ModalModule,
    StoreModule.forFeature(
      STATE_FEATURE_REQUEST_DIGITISATION,
      requestDigitisationReducer,
      { initialState: getInitialRequestDigitisationState },
    ),
    TrapFocusModule,
    UriModule,
  ],
  declarations: [RequestDigitisationModalComponent],
  exports: [RequestDigitisationModalComponent],
  providers: [RequestDigitisationService],
})
export class RequestDigitisationModule {}
